export enum PredefinedColors {
    Blue = '#0077D9',
    Orange = '#D96F2B',
    Green = '#6DAA26',
    Red = '#C22C3E',
    Purple = '#4937BD'
}

type ColorInfo = {
    isSelected: boolean;
}

export interface IStyleAPIData {
    Blue: ColorInfo;
    Green: ColorInfo;
    Orange: ColorInfo;
    Red: ColorInfo;
    Custom: ColorInfo;
    buttonColorCode: string;
    menuColorCode: string;
    previewImage: string;
}

export interface IStylingFormFields {
    appStyles: 'predefinedColor' | 'customColor';
    predefinedColor: {
        color?: string;
    }
    customColor: {
        menuColor: string;
        buttonColor: string;
    }
}
